module.exports = __webpack_public_path__ + "img/down.11db246c.svg";